export default __webpack_public_path__ + "static/media/endFullscreenIcon.965af744.svg";